<template>
  <div class="cat-box">
    <div class="cta-input">
      <el-input placeholder="按钮显示文案" v-model="value.desc"></el-input>
    </div>
    <div class="cta-input">
      <CompPickerLink v-model="value.urlData"></CompPickerLink>
    </div>
  </div>
</template>
<script>
import { cloneDeep } from 'lodash'
import CompPickerLink from '../../comps/comp-pickerLink'
export default {
  name: 'CtaItem',
  components: { CompPickerLink },
  props: ['value'],
  data() {
    return {}
  }
}
</script>
<style scoped lang="scss">
.cat-box {
  .cta-input {
    width: 150px;
    margin-bottom: 10px;
  }
}
</style>
